import { selectors } from 'modules/common';
import { domain } from 'modules/data';

export const isSubscriptionOwner = (
    subscription: selectors.types.ExpandedSubscription,
    profileAccount?: domain.ProfileAccount
) => {
    return profileAccount?.ownerUserProfileId === subscription.accountOwner.databaseId;
};
